import { createSlice } from '@reduxjs/toolkit';
import { EmbajadoresResponse, getEmbajadores } from './embajadoresActions';

interface InitialState {
  embajadoresSuccess: boolean;
  embajadoresData: undefined | EmbajadoresResponse;
  embajadoresLoading: boolean;
  embajadoresError: boolean;
}

const initialState: InitialState = {
  embajadoresSuccess: false,
  embajadoresData: undefined,
  embajadoresLoading: false,
  embajadoresError: false,
};

const embajadoresSlice = createSlice({
  name: 'embajadores',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getEmbajadores.rejected, (state: InitialState) => {
      state.embajadoresError = true;
      state.embajadoresLoading = false;
      state.embajadoresSuccess = false;
      state.embajadoresData = undefined;
    });
    builder.addCase(getEmbajadores.pending, (state: InitialState) => {
      state.embajadoresError = false;
      state.embajadoresLoading = true;
      state.embajadoresSuccess = false;
    });
    builder.addCase(getEmbajadores.fulfilled, (state: InitialState, action) => {
      state.embajadoresData = action.payload;
      state.embajadoresError = false;
      state.embajadoresLoading = false;
      state.embajadoresSuccess = true;
    });
  },
});

export default embajadoresSlice.reducer;
